module.exports = __webpack_public_path__ + "img/whatapp.627d7c70.png";